export default "__VITE_ASSET__CYwiAjxv__"